export const importTemplates = [
  { name: "text.md", format: "short_text", fields: 'answers:\n  - Реостат', question: "Как называется прибор для изменения сопротивления?", answer: "Реостат" },
  { name: "number.md", format: "numeric", fields: 'answers:\n  - 42', question: "Вычислите 6 × 7.", answer: "42" },
  { name: "single.md", format: "single_choice", fields: 'options:\n  - Медь\n  - Дерево\ncorrect: [1]', question: "Выберите проводник электричества.", answer: "Медь" },
  { name: "multiple.md", format: "multiple_choice", fields: 'options:\n  - Медь\n  - Алюминий\n  - Дерево\ncorrect: [1, 2]', question: "Выберите проводники электричества.", answer: "Медь, алюминий" },
];
export function templateMarkdown(index: number) {
  const item = importTemplates[index];
  return `---\nschema_version: podvaltech/1\nid: example-${item.name.replace(".md", "")}\ntitle: Пример задания\nresponse_format: ${item.format}\nscore: 1\nrandom_eligible: true\ntopics:\n  - Пример\n${item.fields}\n---\n# Вопрос\n${item.question}\n\n# Ответ\n${item.answer}\n`;
}
export function downloadTemplate(index: number) {
  const url = URL.createObjectURL(new Blob([templateMarkdown(index)], { type: "text/markdown;charset=utf-8" }));
  const link = document.createElement("a");
  link.href = url;
  link.download = importTemplates[index].name;
  link.click();
  URL.revokeObjectURL(url);
}
